/**
 * 배너 linkUrl 이동 — HOME_MAIN / HOME_SUB / ART_ARTIST 공통.
 *
 * 같은 로직이 Home.vue / HomeSubBannerSwiper.vue 에 복붙돼 있었고
 * ArtistList.vue 에서만 빠져 있어 ART & ARTISTS 배너 링크가 동작하지 않았다.
 * (GitHub #191)
 *
 * @param {string} [linkUrl] 배너의 linkUrl. 없거나 빈 문자열이면 아무 일도 하지 않는다.
 */
export const goToBannerUrl = (linkUrl) => {
  if (!linkUrl) {
    return;
  }
  const url = linkUrl.startsWith('http') ? linkUrl : 'https://' + linkUrl;
  window.open(url, '_blank');
};
